module.exports = __webpack_public_path__ + "static/8-04a055f9b523831d6117a2896cc38eed.jpg";